module.exports = __webpack_public_path__ + "img/dpsy-banner-djlm.77bfd942.png";